<template>
  <div class="coach-dig-container mx-auto p-4 bg-white shadow-md rounded-md max-w-4xl relative">
    <div class="flex items-center justify-between mb-2">
         <router-link to="/" class="no-underline">
             <h1 class="logo-text-pages">interbot.me</h1>
          </router-link>
        </div>
        <h2 class="font-oswald text-2xl text-gray-700">Gemelos Digitales</h2>
        <p class="text-gray-700 mb-4">Sabiduría y experiencia a un clic de distancia.</p>
      <div class="flex items-center gap-2 mb-4">
          <input v-model="searchQuery" type="text" placeholder="Buscar..."
              class="filter-search border rounded p-2 w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-blue-300"/>
      </div>
    <div v-for="coach in filteredCoaches" :key="coach.id" >
       <DigitalCoachCard :coach="coach" @select="selectCoach" :isSelected="selectedCoachId === coach.id" @open="openModal"/>
    </div>
    <SessionModal v-if="showModal" @close="closeModal" >
      <template v-slot:title> Código de Sesión </template>
         <input type="text" v-model="sessionCode" placeholder="Código de sesión (opcional)"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"/>
      <button @click="goToCoachPage"
            class="coach-buy-button bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Ir a la Sesión</button>
    </SessionModal>
 </div>
</template>

<script>
import image4 from "../assets/image-6.jpg";
import image5 from "../assets/image-7.jpg";
import SessionModal from "../components/SessionModal.vue";
import DigitalCoachCard from '../components/DigitalCoachCard.vue';

export default {
components: {
  SessionModal,
     DigitalCoachCard
},
name: 'coachDig',
data() {
  return {
    searchQuery: '',
    showModal: false,
    selectedCoach: null,
   selectedCoachId: null,
      sessionCode: '',
      coaches: [
        {
          id: 1,
            image: image4,
          name: 'Elon',
          title: 'Gemelo Digital de Elon Musk',
            bio2:
            "Elon Musk es un emprendedor prolífico conocido por fundar y liderar varias empresas innovadoras. Es el CEO de SpaceX, donde trabaja para hacer la vida multiplanetaria mediante viajes espaciales reutilizables. Como CEO de Tesla, ha revolucionado la industria automotriz con vehículos eléctricos y energías renovables. Musk cofundó PayPal, cambiando las transacciones financieras online. También está detrás de Neuralink, que desarrolla interfaces cerebro-máquina, y The Boring Company, que busca solucionar el tráfico urbano con túneles subterráneos. Su enfoque visionario redefine lo posible en tecnología y negocios.",
            bio:
            "¿Tienes el carácter para conversar con Elon? Es muy duro, pero si te dejas guiar, te llevará a lugares que nunca imaginaste.",
           labels: [
              "Emprendedor",
              "Innovador",
              "Tecnología",
               "Espacio",
              "Vehículos Eléctricos",
              "Energías Renovables",
            ],
            price: "¡Gratis!",
          available: true,
           coachaddress:"/coachelon",
          showAllLabels: true,
         disclaimer:
             "Este gemelo digital es entrenado con información de fuentes públicas. Elon Musk no está afiliado a este servicio.",
        },
        {
         id: 2,
           image: image5,
         name: 'Warren',
          title: 'Gemelo Digital de Warren Buffet',
          bio2:
              "Warren Edward Buffett es un inversor, empresario y filántropo ampliamente considerado como uno de los inversores más exitosos del siglo XX. Es el Chairman y CEO de Berkshire Hathaway, un conglomerado que posee más de 60 compañías, incluyendo marcas reconocidas como GEICO, Dairy Queen, y Duracell. Buffett comenzó su carrera en inversiones a una edad temprana, comprando su primera acción a los 11 años. Su enfoque de inversión, conocido como 'value investing,' se centra en comprar acciones de compañías subvaluadas con fuertes fundamentos. A lo largo de su carrera, ha transformado Berkshire Hathaway de una compañía textil en quiebra en un gigante corporativo, generando retornos anuales compuestos que superan significativamente al mercado. Su filosofía de inversión y su simplicidad en la toma de decisiones han hecho de él una figura icónica en el mundo de las finanzas.",
          bio:
            "¿Quieres aprender de uno de los inversores más exitosos de la historia? Warren te enseñará los secretos del value investing y cómo tomar decisiones financieras inteligentes.",
          labels: [
              "Inversor",
              "Berkshire Hathaway",
              "Value Investing",
              "Filántropo",
              "Finanzas",
              "Empresario",
          ],
          price: "Modelo Premium",
          available: false,
          showAllLabels: true,
            coachaddress:"",
         disclaimer:
             "Este gemelo digital es entrenado con información de fuentes públicas. Warren Buffet no está afiliado a este servicio.",
        }
      ]
  };
},
 computed: {
     filteredCoaches() {
      let filtered = this.coaches;
      if (this.searchQuery) {
        const searchTerm = this.searchQuery.toLowerCase();
        filtered = filtered.filter(coach => {
          return (
            coach.name.toLowerCase().includes(searchTerm) ||
            coach.title.toLowerCase().includes(searchTerm) ||
              coach.bio.toLowerCase().includes(searchTerm) ||
            coach.labels.some(label => label.toLowerCase().includes(searchTerm))
          );
        });
      }
      return filtered;
    }
  },
  methods: {
  openModal(coach) {
    this.selectedCoach = coach;
    this.showModal = true;
  },
   closeModal() {
    this.showModal = false;
     this.sessionCode = ""; // Limpia el código de sesión
      this.selectedCoach = null; // Limpia el coach seleccionado
  },
  goToCoachPage() {
  if (this.selectedCoach) {
    let coachAddress = this.selectedCoach.coachaddress;
    console.log(coachAddress);

     if (this.sessionCode && coachAddress) {
        let url;
        //si coachAddress es una ruta relativa o no
        if(coachAddress.startsWith('/')){
             url = new URL(location.origin + coachAddress);
        }else if(coachAddress.startsWith('http://') || coachAddress.startsWith('https://')){
             url = new URL(coachAddress);
        }else{
           console.error("La dirección coachAddress no es una ruta valida o una URL:", coachAddress);
           return;
        }

        url.searchParams.append("code", this.sessionCode);
        coachAddress = url.toString();
        console.log(coachAddress);

          // Extraer la ruta relativa de la URL
        const relativePath = url.pathname + url.search;

        this.$router.push(relativePath);
        this.closeModal();
        }
        else if (!coachAddress){
         console.error("La dirección coachAddress esta vacía.");
         return;
        }else{
            this.$router.push(coachAddress);
            this.closeModal();
        }



  }
},
    selectCoach(coachId){
        this.selectedCoachId = this.selectedCoachId === coachId ? null : coachId;
      }
  },
};
</script>